/* eslint-disable no-template-curly-in-string */
import R from 'ramda'

const SEND_INSTAGRAM_DM_DISPLAY_TYPE = 'Send Instagram DM'
const SEND_INSTAGRAM_DM_WIDGET_TYPE = 'SEND_INSTAGRAM_MESSAGE'

const isIgDmFormAction = R.propEq('type', SEND_INSTAGRAM_DM_DISPLAY_TYPE)

const DM_COMPONENT_FIELDS = {
  STANDARD: {
    dmText: 'igDmText',
    dmImageUrl: 'igDmImageUrl',
    dmTemplateTitle: 'igTemplateTitle',
    dmTemplateActionUrl: 'igTemplateActionUrl'
  },
  FALLBACK: {
    dmText: 'igDmFallbackText',
    dmImageUrl: 'igDmFallbackImageUrl',
    dmTemplateTitle: 'igTemplateFallbackTitle',
    dmTemplateActionUrl: 'igTemplateFallbackActionUrl'
  },
  DEPLETED: {
    dmText: 'igDmDepletedText',
    dmImageUrl: 'igDmDepletedImageUrl',
    dmTemplateTitle: 'igTemplateDepletedTitle',
    dmTemplateActionUrl: 'igTemplateDepletedActionUrl'
  }
}
const isPlainTextResponse = dmType => action => {
  const { dmImageUrl } = DM_COMPONENT_FIELDS[dmType]
  return R.pipe(R.prop(dmImageUrl), R.either(R.isNil, R.isEmpty))(action)
}

const constructTemplateBackupMessage = dmType => action => {
  const {
    dmText,
    dmImageUrl,
    dmTemplateTitle,
    dmTemplateActionUrl
  } = DM_COMPONENT_FIELDS[dmType]
  return R.applySpec({
    attachment: {
      type: R.always('template'),
      payload: {
        elements: [
          {
            title: R.prop(dmTemplateTitle),
            subtitle: R.prop(dmText),
            image_url: R.prop(dmImageUrl),
            default_action: {
              url: R.prop(dmTemplateActionUrl),
              type: R.always('web_url'),
              webview_height_ratio: R.always('tall')
            }
          }
        ],
        template_type: R.always('generic')
      }
    }
  })(action)
}

const constructPlainTextResponse = R.applySpec({
  type: R.always(SEND_INSTAGRAM_DM_WIDGET_TYPE),
  message: {
    message: {
      text: R.prop('igDmText')
    },
    fallbackMessage: R.cond([
      [
        R.both(
          R.propEq('includeBackupDms', true),
          isPlainTextResponse('FALLBACK')
        ),
        R.applySpec({ text: R.prop('igDmFallbackText') })
      ],
      [
        R.both(
          R.propEq('includeBackupDms', true),
          R.complement(isPlainTextResponse('FALLBACK'))
        ),
        constructTemplateBackupMessage('FALLBACK')
      ]
    ]),
    depletedMessage: R.cond([
      [
        R.both(
          R.propEq('includeBackupDms', true),
          isPlainTextResponse('DEPLETED')
        ),
        R.applySpec({ text: R.prop('igDmDepletedText') })
      ],
      [
        R.both(
          R.propEq('includeBackupDms', true),
          R.complement(isPlainTextResponse('DEPLETED'))
        ),
        constructTemplateBackupMessage('DEPLETED')
      ]
    ]),
    recipient: {
      id: R.always('${senderId}')
    }
  }
})

const constructImageTemplateResponse = R.applySpec({
  type: R.always(SEND_INSTAGRAM_DM_WIDGET_TYPE),
  message: {
    message: {
      attachment: {
        type: R.always('template'),
        payload: {
          elements: [
            {
              title: R.prop('igTemplateTitle'),
              subtitle: R.prop('igDmText'),
              image_url: R.prop('igDmImageUrl'),
              default_action: {
                url: R.prop('igTemplateActionUrl'),
                type: R.always('web_url'),
                webview_height_ratio: R.always('tall')
              }
            }
          ],
          template_type: R.always('generic')
        }
      }
    },
    fallbackMessage: R.cond([
      [
        R.both(
          R.propEq('includeBackupDms', true),
          isPlainTextResponse('FALLBACK')
        ),
        R.applySpec({ text: R.prop('igDmFallbackText') })
      ],
      [
        R.both(
          R.propEq('includeBackupDms', true),
          R.complement(isPlainTextResponse('FALLBACK'))
        ),
        constructTemplateBackupMessage('FALLBACK')
      ]
    ]),
    depletedMessage: R.cond([
      [
        R.both(
          R.propEq('includeBackupDms', true),
          isPlainTextResponse('DEPLETED')
        ),
        R.applySpec({ text: R.prop('igDmDepletedText') })
      ],
      [
        R.both(
          R.propEq('includeBackupDms', true),
          R.complement(isPlainTextResponse('DEPLETED'))
        ),
        constructTemplateBackupMessage('DEPLETED')
      ]
    ]),
    recipient: {
      id: R.always('${senderId}')
    }
  }
})

const constructGenericTemplateAction = R.cond([
  [isPlainTextResponse('STANDARD'), constructPlainTextResponse],
  [R.T, constructImageTemplateResponse]
])

const constructCustomTemplateAction = R.applySpec({
  type: R.always(SEND_INSTAGRAM_DM_WIDGET_TYPE),
  isCustomTemplate: R.always(true),
  message: R.pipe(
    R.prop('customDmTemplate'),
    JSON.parse,
    R.merge({ recipient: { id: '${senderId}' } })
  )
})

const convertIgFormDmToWidgetDm = R.cond([
  [R.propEq('action', 'TEMPLATE_GENERIC'), constructGenericTemplateAction],
  [R.propEq('action', 'TEMPLATE_CUSTOM'), constructCustomTemplateAction]
])

export { isIgDmFormAction, convertIgFormDmToWidgetDm }



// WEBPACK FOOTER //
// ./src/pages/widgets/mapping/actions/instagram/form-to-widget/send-instagram-dm.js